import { Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '@/helpers/api';
import { useTheme } from '@/helpers/theme';
import Navigation from '@/components/layout/Navigation';
import AppLayout from '@/components/layout/AppLayout';
import SelectAvailabilityDrawer from '@/app/availability/SelectAvailabilityDrawer';

// import { useRequestNotificationPermission } from '@/helpers/notifications';

function App() {
  useAuth();
  useTheme();
  // useRequestNotificationPermission();

  const location = useLocation();

  const navigationHiddenRoutes = [
    '/apply',
    '/setting/coach-activity',
    '/coach/profile',
    '/coach',
    '/conversation/',
    '/application/coach',
    '/card-link'
  ];

  const isHideNavigation = navigationHiddenRoutes.some((route) =>
    location.pathname.startsWith(route)
  );

  return (
    <AppLayout>
      <Outlet />
      {!isHideNavigation && <Navigation />}
      <SelectAvailabilityDrawer />
    </AppLayout>
  );
}

export default App;
